import React from "react";
import { Container, Row, Col, CardImg } from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import StackedTitle from "./layout/StackedTitle";
import parse from "html-react-parser";

const titleGroups = [
    [
        { text: "STRATEGIC" },
        { text: "MATERIALS FOR"},
        { text: "DEFENSE AND", tone: "accent"  },
        { text: "ADVANCED", tone: "accent" },
        { text: "INDUSTRIES", tone: "accent"  },
    ]
];

const banner = {
    background: "banner/defense.png",
    Title: "OUR BUSINESS",
    childTitle: "DEFENSE SYSTEMS, STRATEGIC MATERIALS &<br/>INDUSTRIAL SUPPLY",
    desktopCol: "8"
}

const content1 = {
    title: "DEFENSE SYSTEMS, STRATEGIC MATERIALS & INDUSTRIAL SUPPLY",
    content1: `HM Global Holdings (HMG) supports international defense and industrial programs through strategic sourcing, cross-border trade coordination, export-control advisory, and secure access to mission-critical equipment, materials, and technologies. Working alongside government stakeholders, defense contractors, manufacturers, and specialized industry partners, we help structure and execute complex international programs with a disciplined focus on compliance, supply-chain resilience, operational security, and long-term strategic value.`,

    // content2: `Our focus includes tungsten carbide, antimony, specialty metals, hard alloys, and selected defense-grade commodities where reliability, traceability, compliance, and secure sourcing are essential. Through controlled procurement channels and international supplier relationships, HMG helps partners access materials used in tooling, aerospace-related manufacturing, defense systems, industrial machinery, and mission-critical infrastructure.`
}

const content3 = {
    title: "OUR MISSION",
    content1: `To strengthen secure international defense cooperation, reinforce the resilience of the defense industrial base, and enable responsible cross-border trade aligned with national security, regulatory, and foreign-policy priorities.`,
}

const content = [
    {
        title: "STRATEGIC ADVISORY, COMPLIANCE & EXECUTION",
        subTitle: "",
        content: `<ul><li><span class="font-weight-bold text-info">GOVERNMENT PROGRAMS & INTERNATIONAL SALES</span><span class="text-darker"> Supporting government-to-government and government-linked defense systems through market-entry strategy, stakeholder coordination, procurement planning, and international business development.</span></li><li><span class="font-weight-bold text-info">TECHNOLOGY RELEASE & EXPORTABILITY</span><span class="text-darker"> Developing practical exportability and technology-release strategies to facilitate the authorized and secure transfer of controlled technologies, systems, and technical capabilities.</span></li><li><span class="font-weight-bold text-info">EXPORT CONTROLS & REGULATORY COMPLIANCE</span><span class="text-darker"> Supporting international transactions in accordance with applicable export-control frameworks, including ITAR, sanctions requirements, licensing procedures, and end-user compliance.</span></li><li><span class="font-weight-bold text-info">PROGRAM MANAGEMENT & EXECUTION</span><span class="text-darker"> Translating complex technical, commercial, and regulatory requirements into structured capture strategies, coordinated execution plans, and effective program delivery.</span></li><li><span class="font-weight-bold text-info">STRATEGIC DEFENSE MATERIALS & PROCUREMENT</span><span class="text-darker"> Providing compliant sourcing and distribution of strategic materials, specialty alloys, critical components, and industrial inputs essential to defense manufacturing, heavy industry, and precision engineering.</span></li></ul>`,
        isList: true
    }
]

class DefenseSystems extends React.Component {
    constructor() {
        super();
        this.state = {
            width: window.innerWidth,
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    // make sure to remove the listener
    // when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    render() {
        const isMobile = this.state.width <= 500;
        let style;
        if (isMobile) {
            style = "pt-sm section-components"
        } else {
            style = "section section-components"
        }
        return (
            <>
                <DemoNavbar />
                <main className="defense" ref="main">
                    <ChildPageBanner banner={banner} />
                    <section className={style}>
                        <Container>
                            <section className="section-nucleo-icons" id="whoweare_page">
                                <Row className="align-items-top row-grid">
                                    <Col md="5">
                                        <StackedTitle groups={titleGroups} />
                                    </Col>
                                    <Col md="7">
                                        <div>
                                            <p className="home-child-title-body" id="fb_page">
                                                {content1.title}
                                            </p>
                                            <p className="description-Normal">
                                                {content1.content1}
                                            </p>
                                            {/* <p className="description-Normal">
                                                {content1.content2}
                                            </p> */}
                                        </div>
                                        <div>
                                            <p className="home-child-title-body" id="fb_page">
                                                {content3.title}
                                            </p>
                                            <p className="description-Normal">
                                                {content3.content1}
                                            </p>
                                        </div>
                                        {
                                            content.map((value, index) => {
                                                return (
                                                    <div key={index}>
                                                        <p className="mt-5 home-child-title-body" id="fb_page">
                                                            {parse(value.title)}
                                                        </p>
                                                        <p className="description-Normal">
                                                            {parse(value.subTitle)}
                                                        </p>
                                                        {value.isList ? (
                                                            <div className="mt-4 description-Normal">
                                                                {parse(value.content)}
                                                            </div>
                                                        ) : (
                                                            <p className="mt-4 description-Normal">
                                                                {parse(value.content)}
                                                            </p>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        }
                                    </Col>
                                </Row>
                            </section>
                        </Container>
                    </section>
                </main>
                <Container className="d-flex pb-md">
                    <Row>
                        <Col md="12">
                            <CardImg src="content/defense1.png" alt="Card image cap" />
                        </Col>
                    </Row>
                </Container>
                <CardsFooter />
            </>
        );
    }
}

export default DefenseSystems;
